<template>
    <div>
        <el-form :model="formData" ref="formRef" label-width="95px" size="mini" :inline="true">
            <div class="flex" >
                <el-form-item class="form-title" prop="title" label="标题" style="width: 590px">
                    <div class="mrA">{{formData.title}}</div>
                </el-form-item>
                <el-form-item class="form-title" prop="gsId" label="招标公司" required>
                    <div  style="width: 200px" class="mrA">{{formData.gsName}}</div>

                </el-form-item>
                <el-form-item class="form-title" prop="i_gid" label="招标部门" required>
                    <div style="min-width: 200px" class="mrA">{{formData.vc_gname}}</div>
                </el-form-item>
                <el-form-item class="form-title" prop="i_pztype" label="产品属性" required>
                    <div  style="width: 200px" class="mrA">{{formData.pztypeTxt}}</div>
                </el-form-item>
                <el-form-item class="form-title" prop="payType" label="付款条件" required>
                    <div style="width: 200px" class="mrA">{{formData.payType}}</div>
                </el-form-item>
                <el-form-item class="form-title" prop="i_paydays" label="付款期限" required  v-if="formData.payType=='货到付款'">
                    <div style="width: 200px" class="mrA">{{formData.i_paydays}}</div>
                </el-form-item>
                <el-form-item class="form-title" prop="vc_paytype" label="付款方式" required>
                    <div style="width: 200px" class="mrA">{{formData.vc_paytype}}</div>
                </el-form-item>
                <el-form-item class="form-title" prop="type" label="收货方式" required>
                    <div style="width: 200px" class="mrA">{{formData.type==1?'送货':'自提'}}</div>
                </el-form-item>
                <el-form-item class="form-title" prop="warehouseId" :label="$t('form_warehouse')" required v-if="formData.type==1" >
                    <div  style="width: 200px" class="mrA"> {{formData.warehouseName}}</div>
                </el-form-item>
                <el-form-item class="form-title" prop="warehouseAddressName" label="仓库地址" v-if="formData.type==1" >
                    <div  style="width: 200px" class="mrA">{{formData.warehouseAddressName}}</div>
                </el-form-item>
                <el-form-item class="form-title" prop="duetime" label="截止日期" required>
                    <div  style="width: 200px" class="mrA">{{formData.duetime}}</div>
                </el-form-item>
                <el-form-item class="form-title" prop="i_isdirect" label="定向招标" required>
                    <div  style="width: 200px" class="mrA">{{formData.i_isdirect==1?'是':'否'}}</div>
                </el-form-item>
                <el-form-item class="form-title" prop="directCompanys" label="定向供应商" required v-if="formData.i_isdirect==1">
                    <div v-if="formData.directCompanys&&formData.directCompanys.length>0" style="display: inline-block">
                        <span v-for="(com,index) in formData.directCompanys" :key="com.i_cid">
                            <template v-if="index==0">
                                <span style="color: #333">{{com.vc_cname}}</span>
                                <span v-if="formData.directCompanys.length>1">{{'(等共'+formData.directCompanys.length+'家公司)'}}</span>
                            </template>
                        </span>
                        <el-popover ref="popcom" width="300" trigger="click" v-if="formData.directCompanys.length>1">
                            <div v-for="(com,index) in formData.directCompanys" :key="com.i_cid">{{com.vc_cname}}</div>
                            <el-button type="text"  slot="reference" v-if="index==0">查看</el-button>
                        </el-popover>
                    </div>
                </el-form-item>
            </div>
            <el-table border
                      size="mini"
                      :data="formData.goods"
                      :height="tableHeight"
                      :header-cell-style="{background:'#eef1f6',color:'#000'}"
                      :highlight-current-row="true">
                <el-table-column type="index" :label="$t('form_serial_number')"  width="45" show-overflow-tooltip> </el-table-column>
                <el-table-column  width="100" align="left" prop="pzPName" label="品种大类"  show-overflow-tooltip> </el-table-column>
                <el-table-column  width="200" align="left" prop="pzName" :label="$t('form_product_name')"  show-overflow-tooltip> </el-table-column>
                <el-table-column width="100" align="left" prop="specification" label="规格" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="num" label="需求量" width="80px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="f_addnum"  label="其中追加" width="80px" show-overflow-tooltip></el-table-column>
                <el-table-column align="left"  prop="vc_requires" label="要求">
<!--                    <template slot-scope="scope" >-->
<!--                        <el-input v-model="scope.row.vc_requires" clearable size="mini" ></el-input>-->
<!--                    </template>-->
                </el-table-column>
                <el-table-column prop="i_deliverydays"  label="要求交货周期" width="80px" show-overflow-tooltip></el-table-column>
                <el-table-column  prop="unit" label="计量单位" width="80px" show-overflow-tooltip></el-table-column>
            </el-table>
            <div>
<!--                <span style="font-size: 12px;margin-left: 28px">请上传申购产品说明,规格补充说明等附件.(非必需)</span>-->
                <el-form-item class="form-title "  label="附件" style="margin-bottom: 5px;margin-left: -12px">
                    <template v-if="formData.vc_files&&formData.vc_files.otherfiles.length!=0">
                        <div v-for="(file,index) in formData.vc_files.otherfiles">
                            <a
                                    :download="file.vc_name"
                                    mce_href="#"
                                    :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+file.vc_newname+',tenderapp\'}','utf-8')">
                                <!--:herf="file"-->     {{file.vc_name}}
                            </a>
                        </div>
                    </template>
                    <template v-if="formData.vc_files&&formData.vc_files.signfile">
                        <div v-if="formData.vc_files.signfile.vc_name">
                            <a
                                    :download="formData.vc_files.signfile.vc_name"
                                    mce_href="#"
                                    :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+formData.vc_files.signfile.vc_newname+',tenderapp\'}','utf-8')">
                                <!--:herf="file"-->     {{formData.vc_files.signfile.vc_name}}
                            </a>
                        </div>
                    </template>
                </el-form-item>
            </div>
            <div class="formDiv flex dfjc">
                <div><span style="display: inline-block;width: 80px">发布人:</span>
                    <span>{{formData.fbvc_lruname}}</span>
                </div>
                <div ><span style="display: inline-block;width: 80px">发布日期:</span>
                    <span>{{formData.fbcreateTime}}</span>
                </div>
            </div>
        </el-form>

        <div  class="center ">

            <template v-if="formData.state==1">
                 <el-button type="warning" @click="publish" :disabled="flow" size="small" >发布</el-button>
            </template>
            <el-button @click="cancel" size="small">取 消</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "../../api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";
    export default {
        name: "PublishView",
        props:{
            publishData:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                // goodsList:[],
                baseerp:'',
                token:'',
                i_uid:'',
                file_url: '',
                baseApp:"",
                baseVersion:"",
                tableHeight:0,
                flow:false,
                formData:{},
            }
        },
        watch: {
            publishData: {
                handler() {
                    this.publishView()
                },
                immediate:true,
                deep:true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.token=sessionStorage.getItem("token");
            this.i_uid= sessionStorage.getItem("userid");
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.$nextTick(()=>{
                this.onResize();
            })

        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h*0.5
                if(this.tableHeight<60)this.tableHeight=60
            },
            cancel(){
                this.$emit('close')
            },
            async publishView(){
                let param={
                    i_id:this.publishData.id,
                };
                let res=await API.publishView(param);
                if ( res.code == 1 ){
                    this.formData=res.data
                    this.formData.fbvc_lruname=sessionStorage.getItem("lruname");
                    this.formData.fbcreateTime=this.getDateYYYYMMddHHMMSS();

                    // this.goodsList=res.data.goods;
                    this.$forceUpdate()
                    // console.log(this.goodsList,'this.goodsList')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async publish(){
                this.flow=true
                let param=this.formData;
                let res=await API.publish(param);
                if ( res.code == 1 ){
                    this.flow=false
                    this.$message.success(res.message);
                    this.$emit('refresh')
                    this.cancel()
                }else if (res.code == -2) {
                    this.flow=false
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.flow=false
                    this.$message.error(res.message);
                }
            },
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
    .dfjc{
        display: flex;
        justify-content: space-between
    }
    /deep/{
        .el-form-item--mini.el-form-item{
            margin-bottom: 10px;
        }
    }
</style>